const styles = {
    colors: {
        white: "white",
        grey: "#F2F0FC",
        black: "#002C37",
        red: "#FF0000",
        blue: "#1181C8"
    }
}

export default styles;